'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _OMTwinInput = require('./OMTwinInput.scss');var _OMTwinInput2 = _interopRequireDefault(_OMTwinInput);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var OMTwinInput = function OMTwinInput(properties) {return (
    _react2.default.createElement('div', { className: _OMTwinInput2.default[properties.className] },
      _react2.default.createElement('div', { className: _OMTwinInput2.default.inputWrapper },
        _react2.default.createElement('input', _extends({ type: 'text', pattern: '\\d+ || \'\'' }, properties.field.min, { placeholder: properties.minPlaceholder })),
        _react2.default.createElement('div', { className: _OMTwinInput2.default.title }, properties.minTitle)),

      _react2.default.createElement('div', null, properties.separator),
      _react2.default.createElement('div', { className: _OMTwinInput2.default.inputWrapper },
        _react2.default.createElement('input', _extends({ type: 'text' }, properties.field.max, { placeholder: properties.maxPlaceholder, onBlur: properties.checkMaxValue })),
        _react2.default.createElement('div', { className: _OMTwinInput2.default.title }, properties.maxTitle))));};exports.default =




OMTwinInput;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMTwinInput/OMTwinInput.js
// module id = 2779
// module chunks = 0